import { render } from "./CoinBit.vue?vue&type=template&id=0f06d269"
import script from "./CoinBit.vue?vue&type=script&lang=js"
export * from "./CoinBit.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__